import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useGrades } from '../grades/Grades';
import { useSeries } from '../series/Series';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
  },
  coverImagePicker: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: '#555',
    fontFamily: 'Roboto',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
    borderRadius: '5px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    width: '80%',
  },
}));

function useForm(e) {
  const [entries, setEntries] = useState([]);
  function handleChange(e) {
    let { name, value } = e.target;
    if (typeof value !== 'object') {
      if (value.includes('{') && value.includes('}')) {
        value = JSON.parse(value);
      }
    }
    setEntries({ ...entries, [name]: value });
  }

  return {
    handleChange,
    entries,
  };
}

function QuestionBooleanAnswer(props) {
  const classes = useStyles();
  const options = [
    {
      options: [
        {
          option: 'Verdadero',
          image: '',
        },
        {
          option: 'Falso',
          image: '',
        },
      ],
      correctIndex: 0,
    },
    {
      options: [
        {
          option: 'Verdadero',
          image: '',
        },
        {
          option: 'Falso',
          image: '',
        },
      ],
      correctIndex: 1,
    },
  ];
  return (
    <FormControl variant="outlined" className={classes.input}>
      <InputLabel id="demo-simple-select-label">
        Seléccione la respuesta correcta
      </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        name="questionAnswers"
        value={JSON.stringify(props.answer)}
        onChange={props.handleChange}
      >
        <MenuItem value={JSON.stringify(options[0])}>Verdadero</MenuItem>
        <MenuItem value={JSON.stringify(options[1])}>Falso</MenuItem>
      </Select>
    </FormControl>
  );
}

function QuestionMultipleChoiceAnswer(props) {
  const classes = useStyles();
  const [options, setOptions] = useState([]);
  const [option, setOption] = useState('');
  const [image, setImage] = React.useState('');
  const [coverImage, setCoverImage] = React.useState('');
  const filePickerRef = React.useRef(null);
  const coverImagePreviewRef = React.useRef(null);

  function addOption() {
    let question = { option, image: image };
    setOptions([...options, { ...question }]);
    setOption('');
    setImage('');
  }

  const uploadImages = async (files) => {
    try {
      let formData = new FormData();
      for (const file of files) {
        formData.append('image', file);
      }
      let response = await fetch(
        'https://api.edicionesmilenio.com/api/questions/images',
        {
          method: 'POST',
          body: formData,
        }
      );
      return await response.json();
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const handleDelete = (rowsDeleted) => {
    let ops = [];
    rowsDeleted?.data?.forEach((row, index) => {
      ops = [...ops, options[row?.dataIndex]];
    });
    setOptions(options.filter((option) => !ops.includes(option)));
  };

  return (
    <div style={{ width: '100%' }}>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <TextField
          style={{ height: '30px', marginTop: '10px', marginBottom: '20px' }}
          id="outlined-basic"
          label="Escriba una opcion de respuesta"
          variant="outlined"
          value={option}
          onChange={(e) => setOption(e.target.value)}
          name="question"
        />
      </div>
      <div
        style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
        onClick={() => {
          setCoverImage('');
          filePickerRef.current.click();
        }}
        className={classes.coverImagePicker}
      >
        {coverImage && (
          <img
            style={{ width: '400px', height: 'auto', marginRight: '20px' }}
            ref={coverImagePreviewRef}
            src={
              typeof coverImage === 'string'
                ? 'https://api.edicionesmilenio.com' + coverImage
                : URL.createObjectURL(coverImage)
            }
            alt="preview"
          />
        )}
        <input
          ref={filePickerRef}
          style={{ display: 'none' }}
          type="file"
          name="coverImage"
          onChange={async (e) => {
            let files = e.target.files;
            setCoverImage(files[0]);
            let response = await uploadImages(files);
            if (response.success) {
              setImage(response?.data?.uri);
              const reader = new FileReader();
              reader.onload = (e) => {
                coverImagePreviewRef.current.src = e.target.result;
              };
              reader.readAsDataURL(files[0]);
            }
          }}
          accept="image/*"
        />
        {image && <p>{coverImage?.name}</p>}
        {!image && (
          <p style={{ alignSelf: 'center', justifySelf: 'center' }}>
            Seleccione une imagen para la respuesta
          </p>
        )}
      </div>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <Button
          variant="contained"
          onClick={addOption}
          className={classes.input}
          style={{ background: '#2490AF', color: 'white' }}
        >
          Agregar opción
        </Button>
      </div>
      <div
        style={{
          width: '100%',
          marginTop: '10px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MUIDataTable
          data={options}
          columns={[
            {
              name: 'option',
              label: 'Opciones de respuesta',
            },
            {
              name: 'image',
              label: 'Imagen',
              options: {
                customBodyRenderLite: (dataIndex, rowIndex) => {
                  return (
                    <img
                      style={{
                        width: '100px',
                        height: 'auto',
                        marginRight: '20px',
                      }}
                      src={
                        'https://api.edicionesmilenio.com' +
                        options[dataIndex]?.image
                      }
                      alt="preview"
                    />
                  );
                },
              },
            },
          ]}
          options={{
            search: false,
            download: false,
            print: false,
            viewColumns: false,
            filter: false,
            onRowsDelete: (rowsDeleted) => {
              handleDelete(rowsDeleted);
            },
          }}
        />
      </div>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="answers">Seléccione la respuesta correcta</InputLabel>
          <Select
            id="answers"
            name="questionAnswers"
            value={JSON.stringify(props.answer)}
            onChange={props.handleChange}
          >
            <MenuItem value="" disabled>
              <em>Seleccione la respuesta correcta</em>
            </MenuItem>
            {options.map((option, index) => (
              <MenuItem
                value={JSON.stringify({
                  options: options,
                  correctIndex: index,
                })}
              >
                {option?.option || 'imagen ' + (index + 1)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
}

export function CreateQuestion(props) {
  const classes = useStyles();
  const { handleChange, entries } = useForm();
  const { series } = useSeries();
  const { grades } = useGrades();
  const navigate = useNavigate();
  const [coverImage, setCoverImage] = React.useState('');
  const filePickerRef = React.useRef(null);
  const coverImagePreviewRef = React.useRef(null);

  const activityTypes = [
    'Prueba diagnóstica',
    'Evaluación de periodo',
    'Taller evaluativo 1',
    'Taller evaluativo 2',
    'Taller evaluativo 3',
    'Taller evaluativo 4',
    'Taller evaluativo 5',
    'Taller de práctica 1',
    'Taller de práctica 2',
    'Taller de práctica 3',
    'Taller de práctica 4',
    'Taller de práctica 5',
  ];

  const uploadImages = async (files) => {
    try {
      let formData = new FormData();
      for (const file of files) {
        formData.append('image', file);
      }
      let response = await fetch(
        'https://api.edicionesmilenio.com/api/questions/images',
        {
          method: 'POST',
          body: formData,
        }
      );
      return await response.json();
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  async function submit() {
    let response = await fetch(
      'https://api.edicionesmilenio.com/api/questions',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...entries,
        }),
      }
    );

    if (response.status === 201) {
      navigate('/admin/questions');
    } else {
      alert('Error al crear pregunta, intente de nuevo');
    }
  }
  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <p className={classes.formSpan}>
        Estimado administrador, desde esta sección podrás crear una nueva
        pregunta en la plataforma, recuerda completar todos los campos para que
        el proceso sea más completo. Si la pregunta pertenece a un grupo de
        preguntas de contexto, no olvides seleccionar SI, en la lista
        desplegable.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
        <div
          style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
          onClick={() => {
            setCoverImage('');
            filePickerRef.current.click();
          }}
          className={classes.coverImagePicker}
        >
          {coverImage && (
            <img
              style={{ width: '400px', height: 'auto', marginRight: '20px' }}
              ref={coverImagePreviewRef}
              src={
                typeof coverImage === 'string'
                  ? 'https://api.edicionesmilenio.com' + coverImage
                  : URL.createObjectURL(coverImage)
              }
              alt="preview"
            />
          )}
          <input
            ref={filePickerRef}
            style={{ display: 'none' }}
            type="file"
            name="coverImage"
            onChange={async (e) => {
              setCoverImage(e.target.files[0]);
              let response = await uploadImages(e.target.files);
              handleChange({
                target: {
                  name: 'image',
                  value: response.data.uri,
                },
              });
              const reader = new FileReader();
              reader.onload = (e) => {
                coverImagePreviewRef.current.src = e.target.result;
              };
              reader.readAsDataURL(e.target.files[0]);
            }}
            accept="image/*"
          />
          {coverImage && <p>{coverImage.name}</p>}
          {!coverImage && (
            <p style={{ alignSelf: 'center', justifySelf: 'center' }}>
              Seleccione une imagen para la pregunta
            </p>
          )}
        </div>

        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Enunciado de la pregunta"
          variant="outlined"
          value={entries?.question}
          onChange={handleChange}
          name="question"
          multiline
          style={{ whiteSpace: 'pre-wrap' }}
        />

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-serie">Serie del libro</InputLabel>

          <Select
            onChange={handleChange}
            value={entries?.serie}
            name="serie"
            id="select-serie"
          >
            <MenuItem value="" disabled>
              <em>Seleccione una serie</em>
            </MenuItem>
            {series.map((serie) => (
              <MenuItem value={serie?._id}>{serie?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-grade">Grado</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.grade}
            name="grade"
            id="select-grade"
          >
            <MenuItem value="" disabled>
              <em>Seleccione un grado</em>
            </MenuItem>
            {grades.map((grade) => (
              <MenuItem value={grade?._id}>{grade?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-grade">Periodo</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.period}
            name="period"
            id="select-grade"
          >
            <MenuItem value="" disabled>
              <em>Seleccione un periodo</em>
            </MenuItem>
            <MenuItem value="1">1</MenuItem>
            <MenuItem value="2">2</MenuItem>
            <MenuItem value="3">3</MenuItem>
            <MenuItem value="4">4</MenuItem>
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-grade">Tipo de pregunta</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.questionType}
            name="questionType"
            id="select-grade"
          >
            <MenuItem value="" disabled>
              <em>Seleccione un tipo de pregunta</em>
            </MenuItem>
            <MenuItem value="evaluation">Evaluación</MenuItem>
            <MenuItem value="workshop">Taller</MenuItem>
            {/* <MenuItem value="open">Abierta</MenuItem> */}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-grade">Tipo de actividad</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.activityType}
            name="activityType"
            id="select-grade"
          >
            <MenuItem value="" disabled>
              <em>Seleccione un tipo de actividad</em>
            </MenuItem>
            {activityTypes?.map((activityType) => (
              <MenuItem value={activityType}>{activityType}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-grade">¿Es pregunta contextual?</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.isContextual}
            name="isContextual"
            id="select-grade"
          >
            <MenuItem value="" disabled>
              <em>Seleccione una opción</em>
            </MenuItem>
            <MenuItem value={'true'}>Si</MenuItem>
            <MenuItem value={'false'}>No</MenuItem>
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-grade">Tipo de respuesta</InputLabel>
          <Select
            onChange={handleChange}
            value={entries?.answerType}
            name="answerType"
            id="select-grade"
          >
            <MenuItem value="" disabled>
              <em>Seleccione un tipo de respuesta</em>
            </MenuItem>
            <MenuItem value="boolean">Falso o Verdadero</MenuItem>
            <MenuItem value="multiple">Seleccion multiple</MenuItem>
            {entries?.questionType !== 'evaluation' && (
              <MenuItem value="open">Abierta</MenuItem>
            )}
          </Select>
        </FormControl>

        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Retro alimentación respuesta correcta"
          variant="outlined"
          value={entries?.questionCorrectAnswerMessage}
          onChange={handleChange}
          name="questionCorrectAnswerMessage"
        />

        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Retro alimentación respuesta incorrecta"
          variant="outlined"
          value={entries?.questionIncorrectAnswerMessage}
          onChange={handleChange}
          name="questionIncorrectAnswerMessage"
        />

        <div
          style={{
            display: 'flex',
            paddingTop: '20px',
            paddingBottom: '20px',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          {entries?.answerType === 'boolean' && (
            <QuestionBooleanAnswer
              handleChange={handleChange}
              answer={entries.questionAnswers}
            />
          )}
          {entries?.answerType === 'multiple' && (
            <QuestionMultipleChoiceAnswer
              handleChange={handleChange}
              answer={entries.questionAnswers}
            />
          )}
        </div>

        <Button
          onClick={submit}
          variant="contained"
          style={{ background: '#2490AF', color: 'white' }}
          disabled={
            !entries?.serie ||
            !entries?.grade ||
            !entries?.period ||
            !entries?.questionType ||
            !entries?.activityType ||
            !entries?.isContextual ||
            !entries?.answerType ||
            !(entries?.answerType === 'open')
              ? !entries?.questionAnswers
              : false
          }
        >
          Crear pregunta
        </Button>
      </div>
    </div>
  );
}
